module.exports = __webpack_public_path__ + "img/logo_u1992-15.5ab91169.svg";